import React from "react";
import { useTranslation } from "react-i18next";
import { useColors } from "../../constants/Colors";
import StepWrapper from "./StepWrapper";
import {
  SignupStore,
  PROFILE_TEXT_MAX_LENGTH,
} from "../../hooks/useSignupStore";

interface Props {
  store: SignupStore;
}

const ProfileTextStep: React.FC<Props> = ({ store }) => {
  const { t } = useTranslation();
  const { textNeutralDefault, textNeutralMuted } = useColors();

  const charCount = store.profileText.length;
  const isOverLimit = charCount > PROFILE_TEXT_MAX_LENGTH;

  return (
    <StepWrapper
      title={t("signup.profile_text.title") || "Tell us about yourself"}
      subtitle={
        t("signup.profile_text.subtitle") ||
        "Write a short bio to introduce yourself to potential flatmates (optional)"
      }
    >
      <div className="space-y-4">
        <textarea
          value={store.profileText}
          onChange={(e) => store.setProfileText(e.target.value)}
          placeholder={
            t("signup.profile_text.placeholder") ||
            "I'm a student at ETH, love cooking, and enjoy quiet evenings. Looking for a chill flat with friendly people..."
          }
          maxLength={PROFILE_TEXT_MAX_LENGTH + 100}
          rows={8}
          className="cf-textarea"
          style={{ color: textNeutralDefault }}
          autoFocus
        />
        <div
          className="flex justify-center gap-4 text-sm"
          style={{ color: isOverLimit ? "#DC362E" : textNeutralMuted }}
        >
          <span>
            {t("signup.profile_text.optional") || "This field is optional"}
          </span>
          <span>
            {charCount}/{PROFILE_TEXT_MAX_LENGTH}
          </span>
        </div>
      </div>
    </StepWrapper>
  );
};

export default ProfileTextStep;
